// HU-01 (CM-870): Catálogo genérico de opciones servido desde BD (tabla
// [CT].[CatalogOption] en claims-tracker-api). Reutilizable por país y
// aseguradora. Los valores de CatalogOptionType deben coincidir con la
// columna CatalogType.

export enum CatalogOptionType {
  NOTE_TYPE = 'NOTE_TYPE',
  PENDING_DOC = 'PENDING_DOC',
  NOT_APPLICABLE_REASON = 'NOT_APPLICABLE_REASON',
}

export interface CatalogOption {
  code: string;
  description: string;
  catalogType: string;
}
